function handleQuickAdd(e) {

  if (e.classList.contains('is-disabled') || e.classList.contains('has-success')) {
    return;
  }

  let selectedProducts = [];
  let qty = 1; 
  let variantId = parseFloat(e.dataset.addToCartVariant); 

  selectedProducts = [{
    id: variantId,
    quantity: qty
  }]

  let formData = {
    'items': selectedProducts
  }

  if (selectedProducts.length > 0) {
    e.classList.add('loading');
    e.classList.add('is-disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      e.classList.remove('loading');
      e.classList.remove('is-disabled');
      e.classList.add('has-success');

      setTimeout(() => {
        e.classList.remove('has-success');
        reloadCart();
      }, 1500);
    })
    .catch(err => {
      console.error(err);
    })
  }
}

function reloadCart() {
  document.dispatchEvent(
    new CustomEvent('theme:cart:init', {
      bubbles: true
    })
  );
  document.dispatchEvent(
    new CustomEvent("theme:cart:reload", {
      bubbles: true,
    })
  );
}